import UAParser from 'ua-parser-js';
import MediaQuery from '../lib/MediaQuery';

export default function v1HeaderSvg() {
  /**
   * SVGマップのサイズをブレイクポイントごとに変更する。
   * IEがSVGタグのフルードに対応していないため。
   */
  const mapSvg = document.getElementById('v1-headerDestinations_mapSvg');
  if (!mapSvg) return;
  const svg = mapSvg.querySelector('svg');
  const svgWidth = parseInt(svg.getAttribute('width'), 10);
  const svgHeight = parseInt(svg.getAttribute('height'), 10);

  const setSvgSize = width => {
    const magnification = width / svgWidth;
    svg.setAttribute('width', `${(svgWidth * magnification) / 16}rem`);
    svg.setAttribute('height', `${(svgHeight * magnification) / 16}rem`);
  };

  MediaQuery.matches('xs', matches => {
    if (matches) {
      setSvgSize(320);
    }
  });

  MediaQuery.matches('sm', matches => {
    if (matches) {
      setSvgSize(346);
    }
  });

  MediaQuery.matches('md', matches => {
    if (matches) {
      setSvgSize(621);
    }
  });

  MediaQuery.matches('lg', matches => {
    if (matches) {
      setSvgSize(600);
    }
  });

  MediaQuery.matches('xl', matches => {
    if (matches) {
      setSvgSize(621);
    }
  });

  /**
   * SVGタグ内のaタグをマウスオーバーしたら背景色を変更する。
   * `v1-headerDestinations_prefecture hokkaido`のように設定して、対応するid（ここでは`hokkaido`）と紐づける。
   */
  const svgRegionElm = document.querySelectorAll('.v1-headerDestinations_prefecture');
  const mapColor = '#c9e0ff';
  const hoverColor = '#779EEF';

  const svgOn = e => {
    const link = e.target.closest('.v1-headerDestinations_prefecture');
    const map = document.getElementById(
      // IE11で`SVGElement.classLIst`が使えないため
      link.getAttribute('class').replace('v1-headerDestinations_prefecture ', ''),
    );
    map.style.fill = hoverColor;
  };

  const svgOff = e => {
    const link = e.target.closest('.v1-headerDestinations_prefecture');
    const map = document.getElementById(
      link.getAttribute('class').replace('v1-headerDestinations_prefecture ', ''),
    );
    map.style.fill = mapColor;
  };

  Array.from(svgRegionElm).forEach(item => {
    item.addEventListener('mouseover', e => {
      svgOn(e);
    });

    item.addEventListener('mouseleave', e => {
      svgOff(e);
    });

    item.addEventListener('focus', e => {
      svgOn(e);
    });

    item.addEventListener('blur', e => {
      svgOff(e);
    });
  });

  /**
   * Mac Safariで`<a href="">`があるとフォーカスが効かなくなるので、ページ遷移をJSに変更する。
   */
  const parser = new UAParser();
  const isSafari = parser.getBrowser().name === 'Safari';
  if (isSafari) {
    const prefecture = document.getElementsByClassName('v1-headerDestinations_prefecture');
    const transitionPages = (e, blank) => {
      const url = e.target
        .closest('.v1-headerDestinations_prefecture')
        .getAttribute('data-destinations-map-link');
      if (blank) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    };

    prefecture.forEach(item => {
      item.removeAttribute('href');

      item.addEventListener('click', e => {
        const isCommandKey = !!e.metaKey;
        transitionPages(e, isCommandKey);
      });
      item.addEventListener('keyup', e => {
        const isSelect = !!(e.keyCode === 32 || e.keyCode === 13);
        if (isSelect) {
          transitionPages(e);
        }
      });
    });
  }
}
